import * as moment from 'moment'
import Api from '../Api'

const emptyForm = {
  id: undefined,
  companyId: undefined,
  companyName: undefined,
  companyRegistrationId: '',
  country: 'GB',
  city: 'London',
  plan: 'trial',
  expiresAt: moment(),
  users: []
}

const newSubscriptionForm = {
  namespaced: true,
  state: {
    opened: false,
    form: { ...emptyForm },
    companies: [],
    loadingCompanies: false,
    submitting: false
  },
  mutations: {
    open(state) {
      state.opened = true
    },
    close(state) {
      state.opened = false
      state.form = { ...emptyForm, users: [] }
      state.companies = []
    },
    addUser(state, password) {
      state.form.users.push({email: null, password: password, new: true})
    },
    removeUser(state, index) {
      state.form.users.splice(index, 1)
    },
    update(state, form) {
      state.form = form
    },
    fetchedCompanies(state, data) {
      state.companies = data.companies
      state.loadingCompanies = false
    },
    addCompany(state, company) {
      state.companies.push(company)
    },
    startLoadingCompanies(state) {
      state.loadingCompanies = true
    },
    submitting(state) {
      state.submitting = true
    },
    submitted(state) {
      state.submitting = false
    }
  },
  actions: {
    async fetchCompanies ({ commit }, value) {

      const { data } = await Api.get('/guestroom/companies', {
        params: { value }
      })

      commit('fetchedCompanies', data)
    },
    async createCompany( { commit }, subscription) {
      const { data } = await Api.post('/guestroom/companies', {name: subscription.companyName, registration_id: subscription.companyRegistrationId})
      return data
    },
    async createSubscription({ dispatch, commit }, subscription) {
      commit('submitting')
      const { company } = await dispatch('createCompany', subscription)
      
      const params = Object.assign({}, subscription, {
        companyId: company.id,
        expiresAt: subscription.expiresAt.toDate()
      })

      const { data } = await Api.post('/guestroom/subscriptions', params)

      commit('subscriptions/addNew', data.subscription, { root: true })
      commit('notification/show', { type: "success", message: "Hurrah!", description: "New subscription successfully created." }, { root: true })
      commit('close')
      commit('submitted')
    },
    async updateSubscription({ dispatch, commit }, subscription) {
      commit('submitting')
      const { company } = await dispatch('createCompany', subscription)

      const params = Object.assign({}, subscription, {
        companyId: company.id,
        expiresAt: subscription.expiresAt.toDate()
      })

      const { data } = await Api.put(`/guestroom/subscriptions/${params.id}`, params)

      commit('subscriptions/updateExisting', data.subscription, { root: true })
      commit('notification/show', { type: "success", message: "Hurrah!", description: "Subscription successfully updated." }, { root: true })
      commit('close')
      commit('submitted')
    },
    async deleteLicense({ dispatch, commit, state }, { user, subscriptionId }) {
      if(!user.new && subscriptionId) {
        const params = { email: user.email }
        const { data } = await Api.delete(`/guestroom/licenses/${subscriptionId}`, { params })
        commit('subscriptions/updateExisting', data.subscription, {root: true})
      }
    }
  },
  getters: {
    getCompany: (state) => (id) => {
      return state.companies.find(c => c.id === id)
    }
  }
}

export default newSubscriptionForm